module.exports = __webpack_public_path__ + "img/progress_icon.3075534e.svg";